// Labels por defecto en español para el admin
export const DEFAULT_LABELS = {
  home: {
    santo_del_dia: 'Santo del día',
    liturgia_horas: 'Liturgia de las horas',
    misa_del_dia: 'Misa del día',
    propios: 'Comunes',
    santoral: 'Santoral',
    calendario_liturgico: 'Calendario litúrgico',
    oraciones: 'Oraciones',
    celebraciones: 'Celebraciones',
    aniversarios: 'Aniversarios',
    maximas: 'Máximas',
    multimedia: 'Multimedia',
    constituciones: 'Constituciones',
    directorio: 'Directorio',
    acuerdos_capitulares: 'Acuerdos capitulares',
    ano_liturgico: 'Año litúrgico',
    cerrar_sesion: 'Cerrar sesión',
  },
};

// Función para obtener un label específico
export const getLabel = (module: string, key: string): string => {
  const defaultModule = DEFAULT_LABELS[module as keyof typeof DEFAULT_LABELS];
  if (defaultModule) {
    return (defaultModule as any)[key] || key.toUpperCase().replace(/_/g, ' ');
  }
  return key.toUpperCase().replace(/_/g, ' ');
};

// Función helper específica para home
export const getHomeLabel = (key: string): string => {
  return getLabel('home', key);
};
